export const SVG_TREE = 'svgTree'
export const CANVAS_TREE = 'canvasTree'
export const JSON_VIEWER = 'jsonViewer'
